interface currencyFields {
  key: string;
  isCurrency: boolean;
}

const currencyFields: currencyFields[] = [
  { key: 'gross_total', isCurrency: true },
  { key: 'vat_amount', isCurrency: true },
  { key: 'adjustment_amount', isCurrency: true },
  { key: 'discount', isCurrency: true },
  { key: 'gold_rate', isCurrency: true },
  { key: 'grand_total', isCurrency: true },
  { key: 'purchase_amount', isCurrency: true },
  { key: 'taxable_amount', isCurrency: true },
  { key: 'taxableAmount', isCurrency: true },
  { key: 'tax_amount', isCurrency: true },
  { key: 'tax', isCurrency: true },
  { key: 'taxAmount', isCurrency: true },
  { key: 'vatAmount', isCurrency: true },
  { key: 'totalNetWeight', isCurrency: false },
  { key: 'totalNetWithWastage', isCurrency: false },
  { key: 'totalPureWeight', isCurrency: false },
  { key: 'totalDiamondWeight', isCurrency: false },
  { key: 'totalStoneWeight', isCurrency: false },
  { key: 'totalDiamondPcs', isCurrency: false },
  { key: 'totalStonePcs', isCurrency: false },
  { key: 'totalDiamondAmount', isCurrency: true },
  { key: 'totalStoneAmount', isCurrency: true },
];

export default currencyFields;
